function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\r\n\t\t.st11{fill:#231F20;}\r\n\t");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  className: "postpone"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st11",
  d: "M50,100C22.4,100,0,77.6,0,50C0,22.4,22.4,0,50,0c27.6,0,50,22.4,50,50C100,77.6,77.6,100,50,100z M50,3.3 C24.3,3.3,3.3,24.3,3.3,50S24.3,96.7,50,96.7S96.7,75.7,96.7,50S75.7,3.3,50,3.3z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st11",
  d: "M50,75.8c-14.2,0-25.8-11.6-25.8-25.8c0-14.2,11.6-25.8,25.8-25.8c14.2,0,25.8,11.6,25.8,25.8 C75.8,64.2,64.2,75.8,50,75.8z M50,68.6c0.7,0,1.2,0.6,1.2,1.2v2.9l1.4-0.2c10.4-1.2,18.8-9.6,20-20l0.2-1.4h-2.9 c-0.7,0-1.2-0.6-1.2-1.2s0.6-1.2,1.2-1.2h2.9l-0.2-1.4c-1.2-10.4-9.6-18.8-20-20l-1.4-0.2v2.9c0,0.7-0.6,1.2-1.2,1.2 c-0.7,0-1.2-0.6-1.2-1.2v-2.9l-1.4,0.2c-10.4,1.2-18.8,9.6-20,20l-0.2,1.4h2.9c0.7,0,1.2,0.6,1.2,1.2s-0.6,1.2-1.2,1.2h-2.9 l0.2,1.4c1.2,10.4,9.6,18.8,20,20l1.4,0.2v-2.9C48.8,69.2,49.3,68.6,50,68.6z M50,51.9c-0.8,0-1.4-0.6-1.4-1.4V38.9 c0-0.8,0.6-1.4,1.4-1.4c0.8,0,1.4,0.6,1.4,1.4v10.2h6.3c0.8,0,1.4,0.6,1.4,1.4s-0.6,1.4-1.4,1.4H50z"
})))));

var SvgPostpone = function SvgPostpone(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 100",
    style: {
      enableBackground: "new 0 0 100 100"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPostpone, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/postpone.568950b0.svg";
export { ForwardRef as ReactComponent };